import { ref, watch } from 'vue';

const STORAGE_KEY = 'dmp_shared_date_range';

/**
 * デフォルトの表示期間(今日〜7日後)
 */
export const defaultDateRange = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const sevenDaysLater = new Date(today);
  sevenDaysLater.setDate(today.getDate() + 7);
  return { startDate: today, endDate: sevenDaysLater };
};

const restore = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return defaultDateRange();
    }
    const parsed = JSON.parse(raw);
    const startDate = new Date(parsed.startDate);
    const endDate = new Date(parsed.endDate);
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      return defaultDateRange();
    }
    return { startDate, endDate };
  } catch {
    return defaultDateRange();
  }
};

// Module-scoped: every page shares the same selected range within the tab
const dateRange = ref(restore());

watch(dateRange, (value) => {
  if (!value?.startDate || !value?.endDate) {
    return;
  }
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
      startDate: value.startDate.toISOString(),
      endDate: value.endDate.toISOString(),
    }));
  } catch {
    // Storage unavailable (private mode etc.) — sharing still works in-tab
  }
}, { deep: true });

/**
 * ダッシュボード・イベント・宿泊で共有する表示期間。
 * どのページで変更しても、他のページに移動したとき引き継がれる。
 */
export function useSharedDateRange() {
  return { dateRange };
}
